import React, { useState } from "react";
import {
  Box,
  Button,
  Input,
  Modal,
  ModalBody,
  ModalContent,
  ModalFooter,
  ModalHeader,
  ModalOverlay,
  Text,
  VStack,
} from "@chakra-ui/react";
import { useDispatch, useSelector } from "react-redux";
import { closeAddVoucherModel } from "../../../modules/admin-modules/models/Actions";
import { addVoucherRequest } from "../../../modules/students-modules/videos/Actions";
import { studentPalette } from "../../../constants/studentPalette";

const shellBg = "#3d1824";
const accent = studentPalette.crimson;
const cream = studentPalette.cream;
const primary = studentPalette.primary;

const AddVoucher = () => {
  const dispatch = useDispatch();
  const isOpen = useSelector((state) => state.model.isOpen21);
  const videoId = useSelector((state) => state.model.payload);
  const voucherLoading = useSelector((state) => state.chapterVideos.voucherLoading);
  const [voucherData, setVoucherData] = useState("");

  const handleClose = () => {
    setVoucherData("");
    dispatch(closeAddVoucherModel());
  };

  const handelSendVoucher = () => {
    const formData = new FormData();
    formData.append("voucher", voucherData);
    formData.append("video_id", videoId);

    dispatch(
      addVoucherRequest({
        formData: {
          formData,
        },
        action: () => {
          handleClose();
        },
      })
    );
  };

  return (
    <Modal isOpen={isOpen} onClose={handleClose} isCentered size="md">
      <ModalOverlay bg="rgba(91, 13, 22, 0.88)" backdropFilter="blur(8px)" />
      <ModalContent
        bg={shellBg}
        borderRadius="2xl"
        borderWidth="1px"
        borderColor="whiteAlpha.200"
        boxShadow="0 25px 50px -12px rgba(0,0,0,0.45)"
        mx={3}
      >
        <ModalHeader pb={0} pt={8} px={8}>
          <Text fontSize="10px" fontWeight="800" color={accent} textTransform="uppercase" letterSpacing="0.2em" mb={2}>
            Session access
          </Text>
          <Text color="white" fontSize="xl" fontWeight="800" letterSpacing="tight">
            Add voucher code
          </Text>
          <Text color={`${cream}99`} fontSize="sm" fontWeight="500" mt={2}>
            Enter the code you received from your assistant to restore watch access for this session.
          </Text>
        </ModalHeader>
        <ModalBody px={8} pt={6} pb={2}>
          <VStack align="stretch" spacing={3}>
            <Text fontSize="10px" fontWeight="800" color={accent} textTransform="uppercase" letterSpacing="0.14em">
              Voucher code
            </Text>
            <Input
              value={voucherData}
              onChange={(e) => setVoucherData(e.target.value)}
              placeholder="Paste code here"
              size="lg"
              bg="whiteAlpha.100"
              borderColor="whiteAlpha.300"
              color="white"
              borderRadius="xl"
              _placeholder={{ color: "whiteAlpha.400" }}
              _hover={{ borderColor: "whiteAlpha.400" }}
              _focus={{ borderColor: cream, boxShadow: `0 0 0 1px ${cream}` }}
            />
          </VStack>
        </ModalBody>
        <ModalFooter px={8} pb={8} pt={4} gap={3} flexWrap="wrap">
          <Button
            flex={{ base: "1 1 100%", sm: "1" }}
            variant="outline"
            borderColor="whiteAlpha.400"
            color={cream}
            borderRadius="xl"
            fontWeight="800"
            textTransform="uppercase"
            fontSize="xs"
            letterSpacing="0.08em"
            _hover={{ bg: "whiteAlpha.100" }}
            onClick={handleClose}
          >
            Cancel
          </Button>
          <Button
            flex={{ base: "1 1 100%", sm: "1" }}
            bg="white"
            color={primary}
            borderRadius="xl"
            fontWeight="800"
            textTransform="uppercase"
            fontSize="xs"
            letterSpacing="0.08em"
            isLoading={voucherLoading}
            loadingText="Saving"
            _hover={{ bg: cream }}
            onClick={handelSendVoucher}
          >
            Apply voucher
          </Button>
        </ModalFooter>
      </ModalContent>
    </Modal>
  );
};

export default AddVoucher;
